import React, {useState} from 'react';

import {useAccountSettingsState} from 'app/settings/api';
import {UpdateMaxUsersLimitModal} from 'app/stripebilling/components/UpdateMaxUsersLimitModal';
import {gt} from 'app/utils/i18n';

export function MaxMembersLimitRow() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    is_no_active_users,
    is_paying,
    max_users_limit: maxUsersLimit,
    account_id: accountId,
  } = useAccountSettingsState().data!;

  if (!is_no_active_users) {
    return null;
  }

  if (!is_paying) {
    return null;
  }

  return (
    <>
      <div className="row pt-2 mt-2">
        <div className="col-12 col-sm-3 section-name">
          {gt('Max members limit')}
        </div>
        <div className="col-12 col-sm-9 section-data">
          <div className="row">
            <div className="col-12 col-sm">
              <span>{maxUsersLimit}</span>
              <div className="note mt-1">
                <i>
                  *
                  {gt(
                    'This is the maximum number of members that can be added to your account. You can increase this limit if you want to allow adding more members'
                  )}
                </i>
              </div>
            </div>
            <div className="col-auto mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => setIsModalOpen(true)}
              >
                {gt('Update Limit')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <UpdateMaxUsersLimitModal
        accountId={accountId}
        show={isModalOpen}
        currentLimit={maxUsersLimit}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
